import React from 'react';
import { Text } from '../../../globalStyles';
import { EditHandbookInput } from '../EditHandbookInput';
import { SectionRow, SectionRowItem } from './SectionRow';
import type { EdibleSectionProps, EditableSectionRowInfo, HandBookInfo } from './types';
import { EditOrganizationHandbookInput } from '../../../graphQL';

type Props = EdibleSectionProps & {
  organizationId: number;
  editable?: boolean;
  handbookInfo: HandBookInfo;
  refetch: () => void;
  selectedField: keyof HandBookInfo | null;
  setSelectedField: (editFieldName: keyof HandBookInfo | null) => void;
  openEdit: (item: keyof HandBookInfo) => (() => void) | undefined;
  editableSectionRowInfo: EditableSectionRowInfo[] | undefined;
  submitFunction: (
    editFieldName: keyof EditOrganizationHandbookInput
  ) => (value: string) => Promise<void>;
  verticalDisplay?: boolean;
};

export const titleEmergencyProtocol = 'Emergency Protocol';

export function EmergencyProtocolSection({
  handbookInfo,
  selectedField,
  editableSectionRowInfo,
  verticalDisplay,
  onStartEdit,
  onCancelEdit,
  onSave,
}: Props) {
  const sectionRows = editableSectionRowInfo?.map(row => (
    <SectionRow verticalDisplay={verticalDisplay} label={row.label} info={row.info}>
      <SectionRowItem onEditClick={onStartEdit ? () => onStartEdit(row.displayKey) : undefined}>
        {selectedField === row.displayKey ? (
          <EditHandbookInput
            handbookRowInfo={String(handbookInfo[row.displayKey])}
            selectedField={row.displayKey}
            onCancel={onCancelEdit}
            onSave={onSave ? value => onSave(row.editInputKey, value) : undefined}
          />
        ) : (
          <Text.bodySmall>{handbookInfo[row.displayKey]}</Text.bodySmall>
        )}
      </SectionRowItem>
    </SectionRow>
  ));

  return <div>{sectionRows}</div>;
}
